import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SquareFloatButton.style.css';
//import Top from 'assets/icon/top_icon.png';
import ArrowUp from 'assets/arrow_up.svg';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { encrypt } from 'utils/Crypto';

const SquareFloatButton = ({
  children,
  onClick = () => {},
  size = 52,
  style = {},
}) => {
  /* ===== Route ===== */
  const navigate = useNavigate();

  /* ===== Props ===== */
  /* ===== State ===== */
  const getRecentList = sessionStorage.getItem('recent-list');

  const [recent, setRecent] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (!getRecentList?.length || !getRecentList) return;

    const parseData = JSON.parse(getRecentList) || [];
    setRecent(parseData);
  }, [getRecentList]);

  /* ===== Render ===== */
  return (
    <div className="square_float_button_group">
      <div className="square_float_button square_float_button_default hidden">
        <img src={ArrowUp} alt="펼쳐보기" />
      </div>
      <button
        className="square_float_button square_float_button_default"
        onClick={() => navigate('/mypage/wishlist/wishlist')}
      >
        위시리스트
      </button>
      <button
        className="square_float_button square_float_button_default"
        onClick={() => navigate('/products?type=present')}
      >
        선물하기
      </button>
      <button
        className="square_float_button square_float_button_default"
        onClick={() => navigate('/cs/notice/hZsTD8bG3Kn2XCUKxyL1Ow%3D%3D')}
      >
        멤버십 혜택
      </button>
      <button
        className="square_float_button square_float_button_default"
        onClick={() => navigate('/order/cart?type=delivery')}
      >
        장바구니
      </button>
      {recent && recent.length ? (
        <React.Fragment>
          <div className="square_float_button square_float_button_default resently_saw">
            {recent
              ?.slice((currentPage - 1) * 2, currentPage * 2)
              ?.map((item, index) => (
                <div
                  key={`product-${item.key}-${index}`}
                  onClick={() =>
                    navigate(
                      `/products/${encodeURIComponent(encrypt(item.key))}`,
                    )
                  }
                >
                  <img
                    src={item?.thumbnail}
                    alt={item?.title}
                    width={'100%'}
                    height={'100%'}
                  />
                </div>
              ))}
          </div>
          <div className="square_float_button square_float_button_default resently_saw arrow">
            <Button
              size="small"
              icon={<LeftOutlined />}
              width={10}
              type="text"
              //style={{ width: 14, height: 14 }}
              disabled={currentPage === 1 ? true : false}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            />
            <span style={{ minWidth: 'fit-content' }}>
              {currentPage} /{' '}
              {!recent || !recent.length ? 0 : Math.ceil(recent.length / 2)}
            </span>
            <Button
              size="small"
              icon={<RightOutlined />}
              type="text"
              //style={{ width: 14, height: 14 }}
              disabled={
                Math.ceil(recent.length / 2) === currentPage ? true : false
              }
              onClick={() => setCurrentPage((prev) => prev + 1)}
            />
          </div>
        </React.Fragment>
      ) : null}

      <button
        className="square_float_button square_float_button_default top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        TOP
      </button>
    </div>
  );
};

export default SquareFloatButton;
